{
  "type": "object",
  "properties": {
    "registerPage1": {
      "type": "object",
      "properties": {
        "title": {
          "required": true,
          "title": "Salutation",
          "validationMessages": {
            "required": "Please select Salutation."
          }
        },
        "gender": {
          "title": "Gender"
        },
            "firstName": {
              "required": true,
              "title": "First Name",
              "maxlength": "40",
              "validationMessages": {
                "required": "Missing First Name.",
                "maxlength": "Max 40 characters"
              }
            },
            "lastName": {
              "required": true,
              "title": "Last Name",
              "maxlength": "40",
              "validationMessages": {
                "required": "Missing Last Name.",
                "maxlength": "Max 40 characters"
              }
            },
            "email": {
              "required": true,
              "type": "email",
              "title": "Email (User Name)",
              "maxlength": "100",
              "validationMessages": {
                "required": "Missing Email.",
                "email": "Enter valid Email",
                "maxlength": "Max 100 characters"
              }
            },
            "password": {
              "required": true,
              "title": "Password",
              "minlenth": "8",
              "maxlength": "40",
              "passwordValidate": "",
              "validationMessages": {
                "required": "Missing Password.",
                "minlength": "Min 8 characters",
                "maxlength": "Max 40 characters",
                "passwordValidate": "Your password must be at least 8 characters long and alphanumeric."
              }
            },
            "confirmPassword": {
              "required": true,
              "title": "Confirm Password",
              "maxlength": "40",
              "areEqual": {
                "fieldToValidate": "password"
              },
              "validationMessages": {
                "required": "Missing Confirm Password.",
                "maxlength": "Max 40 characters",
                "areEqual": "Please check that your passwords match and try again."
              }
            }
          }
        },
        "registerPage2": {
          "type": "object",
          "properties": {
            "countryId": {
              "required": true,
              "title": "Country",
              "validationMessages": {
                "required": "Please select Country of Residence."
              }
            },
            "phoneCode": {
              "title": "Code",
              "maxlength": "10",
              "validationMessages": {
                "maxlength": "Max 10 characters"
              }
            },
            "mobile": {
              "title": "Mobile",
              "maxlength": "40",
              "pattern": "[0-9]*",
              "validationMessages": {
                "maxlength": "Max 40 characters",
                "pattern": "Only Number"
              }
            },
            "organization": {
              "required": true,
              "maxlength": "100",
              "title": "Company",
              "validationMessages": {
                "required": "Missing Company.",
                "maxlength": "Max 100 characters"
              }
            },
            "otherJobTitle": {
              "required": true,
              "title": "Job Title",
              "maxlength": "100",
              "validationMessages": {
                "required": "Please select your Job Title.",
                "maxlength": "Max 100 characters"
              }
            },
            "agreeToPrivacyPolicy": {
              "title": ""
            },
            "agreeToPrivacyPolicyTitle": {
              "title": "By registering I confirm that I have read and agree to the <a href='https://www.edgebuildings.com/contact-us/privacy/' target='_blank'>Privacy Policy</a> and <a href='https://www.edgebuildings.com/contact-us/terms-of-use/' target='_blank' title='{{AuthenticatePages.TermsofUse}}'>Terms of Use</a>."
            },
            "wishToReceiveEmail": {
              "title": ""
            },
            "captchaInput": {
              "title": "",
              "pattern": "[0-9]*",
              "maxlength": "3",
              "validationMessages": {
                "required": "Incorrect answer for Captcha. Please try again.",
                "pattern": "Only Number",
                "maxlength": "Max 3 Numbers"
              }
            },
            "reloadCaptcha": {
              "title": ""
            },
            "captchaSrc": {
              "title": ""
            },
            "recaptcha": {
              "title": "recaptcha"
            },
            "recaptchResponse": {
              "title": ""
            }
          }
        }
      }
}
